import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import Button from '../../../core/form/Button';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import Card from '../../../core/layout/Card';
import WhitelabelConfigFormContainer from './WhitelabelConfigFormContainer';
import Separator from '../../../core/layout/Separator';
import WhitelabelConfigWebDistributionContainer from './WhitelabelConfigWebDistributionContainer';
import WhitelabelConfigMobileDistributionListContainer from './WhitelabelConfigMobileDistributionListContainer';
import WhitelabelConfigMobileDistributionFormContainer from './WhitelabelConfigMobileDistributionFormContainer';
import WhitelabelConfigAuthenticationOptionsContainer from './WhitelabelConfigAuthenticationOptionsContainer';
import WhitelabelConfigCustomOptionsFormContainer from './WhitelabelConfigCustomOptionsFormContainer';
import WhitelabelConfigColorPaletteFormContainer from './WhitelabelConfigColorPaletteFormContainer';

const WhitelabelConfigFormScene = (props) => (
  <div>
    <Breadcrumb
      crumbs={[
        {
          text: `${props.params.whitelabelConfigId ? 'Edit Whitelabel Config' : 'Create Whitelabel Config'}`,
        },
      ]}
    />
    <Card
      title={props.params.whitelabelConfigId ? 'Edit Whitelabel Config' : 'Create Whitelabel Config'}
      actions={<Button icon="arrow-left" label="Back" type="default" onClick={() => browserHistory.goBack()} />}
    >
      <WhitelabelConfigFormContainer whitelabelConfigId={props.params.whitelabelConfigId} />
    </Card>
    {props.params.whitelabelConfigId && (
      <React.Fragment>
        <Separator />
        <Card
          title="Color Palette Setup"
          collapsible
          initialCollapse={false}
          actions={
            <label style={{ margin: '0 12px 0px 0px' }}>
              Link para pegar json de cores da paleta:{' '}
              <a href="https://uicolors.app" target="_blank" rel="noopener noreferrer">
                https://uicolors.app
              </a>
            </label>
          }
        >
          <WhitelabelConfigColorPaletteFormContainer whitelabelConfigId={props.params.whitelabelConfigId} />
        </Card>
        <Separator />
        <Card title="Custom Options" collapsible initialCollapse>
          <WhitelabelConfigCustomOptionsFormContainer whitelabelConfigId={props.params.whitelabelConfigId} />
        </Card>
        <Separator />
        <Card title="Authentication Options" collapsible initialCollapse>
          <WhitelabelConfigAuthenticationOptionsContainer whitelabelConfigId={props.params.whitelabelConfigId} />
        </Card>
        <Separator />
        <Card title="Web Distributions Config" collapsible initialCollapse>
          <WhitelabelConfigWebDistributionContainer whitelabelConfigId={props.params.whitelabelConfigId} />
        </Card>
        <Separator />
        <Card title="Mobile Distributions Config" collapsible initialCollapse>
          <WhitelabelConfigMobileDistributionListContainer whitelabelConfigId={props.params.whitelabelConfigId} />
          <WhitelabelConfigMobileDistributionFormContainer />
        </Card>
      </React.Fragment>
    )}
  </div>
);

WhitelabelConfigFormScene.propTypes = {
  params: PropTypes.shape({
    whitelabelConfigId: PropTypes.string,
  }),
};

WhitelabelConfigFormScene.defaultProps = {
  params: null,
};

export default WhitelabelConfigFormScene;
